import { Modal, Button, Icon, Input, InputNumber, message } from "antd";
import * as React from "react";
import API, { getAxiosInstance } from "../../api/api";
export class ModifyEsimatedAmount extends React.Component<any, any> {
  state = { visible: false, value: this.props.delivery.amounts, loading: false};
  lbpAmount = this.state.value.find((x) => x.currencyId == 1)
  usdAmount = this.state.value.find((x) => x.currencyId == 2)
  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = e => {
    console.log(e);
    this.setState({
      loading: true
    });
    let amountsToSend = [{}];

    this.state.value.forEach(element => {
      var temp={
        currencyId: element.currencyId,
        amount: element.amount
      };
      amountsToSend.push(temp);
    });

    amountsToSend = amountsToSend.slice(1, amountsToSend.length)
    getAxiosInstance()
      .post(API.modify_estimated_amount, {
        deliveryId: this.props.delivery.id,
        amounts: amountsToSend
      })
      .then(response => {
        console.log(response);
        message.success("Successfully changed");
        this.props.updateData();
        this.setState({
          visible: false,
          loading: false
        });
      })
      .catch(err => {
        message.error("Something went wrong");
        console.error(err);
        this.setState({
          visible: false,
          loading: false
        });
      });
  };

  handleCancel = e => {
    console.log(e);
    this.setState({
      visible: false
    });
  };

  onChange = a => (event) =>{
    let old = this.state.value;
    if(a == 1){
      this.lbpAmount = {amount: event}
      if(old.find((x) => x.currencyId == 1) != null){
        old.find((x) => x.currencyId == 1).amount = event
      } else {
        let obj = {
          currencyId : 1,
          currencyName : "LBP",
          amount : event,
          numberFormat : "#,###",
          hint : "LBP",
        }
        old.push(obj)
      }
    } else if  (a == 2){
      this.usdAmount = {amount: event}
      if(old.find((x) => x.currencyId == 2) != null){
        old.find((x) => x.currencyId == 2).amount = event
      } else {
        let obj = {
          currencyId : 2,
          currencyName : "USD",
          amount : event,
          numberFormat : "#,###",
          hint : "USD",
        }
        old.push(obj)
      }
    }
    this.setState({value: old});

    };

  render() {
    const { delivery } = this.props;
    return (
      <>
        <Button size="small" type="primary" onClick={this.showModal}>
          <Icon type="edit" />
        </Button>
        <Modal
          confirmLoading={this.state.loading}
          closable={!this.state.loading}
          title="Modify Amounts List"
          visible={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <div>
              <span>LBP</span>
              <InputNumber
                onChange={this.onChange(1)}
                min={0}
                value={this.lbpAmount == undefined ? null : this.lbpAmount.amount}
                style={{width: "200px", margin: "10px"}}
              />
            </div>
            <div>
              <span>USD</span>
              <InputNumber
                onChange={this.onChange(2)}
                min={0}
                value={this.usdAmount == undefined ? null : this.usdAmount.amount}
                style={{width: "200px", margin: "10px"}}
              />
            </div>
        </Modal>
      </>
    );
  }
}
